import { DEFAULT_TITLE as e, formatPageTitle as t } from "@maat/api-main/types";
//#region src/formatTitle.ts
var n = (e) => t(e), r = e;
//#endregion
export { r as DEFAULT_TITLE, n as formatTitle };
